import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=013874d5&"
import script from "./ActivityCard.vue?vue&type=script&lang=js&"
export * from "./ActivityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports